import React from 'react';
import { TextField } from '@material-ui/core';
import InputMask from 'react-input-mask';

function CustomInputMask(props) {
  const { inputRef, mask, ...other } = props;

  return (
    <InputMask
      {...other}
      ref={(ref) => {
        inputRef(ref ? ref.inputElement : null);
      }}
      mask={mask}
    />
  );
}

export default function DocumentField({ label, mask, document, onChangeDocument, error, helperText }) {
  return (
    <TextField
      // fullWidth
      label={label || "Documento"}
      value={document}
      error={error}
      helperText={helperText}
      onChange={e => onChangeDocument(e.target.value)}
      InputProps={{
        inputProps: {mask},
        inputComponent: CustomInputMask,
      }}
      InputLabelProps={{
        shrink: true
      }}
    />
  )
}